<!--
  Wrapper class listening for the global flash event

  Handling displaying and hiding of messages
-->
<template>
    <div class="flash-stack">
        <transition-group tag="div" name="flash-fade" appear>
            <flash
                v-for="(message, index) in messages"
                :object="message"
                @hide="hideMessage"
                v-show="message.show"
                :numberInStack="index"
                :key="message.numberInStack"
            />
        </transition-group>
    </div>
</template>

<script>
import { EventBus } from '../eventbus.js';

export default {
    data() {
        return {
            messages: []
        };
    },
    created() {
        /**
         * Listen for global flash event,
         * prepare" given object for rendering as Flash component
         */
        EventBus.$on('flash', object => {
            object.numberInStack = this.messages.length;
            object.show = true;
            this.messages.push(object);
        });
    },
    methods: {
        hideMessage(numberInStack) {
            this.messages.forEach((element) => {
                if (element.numberInStack === numberInStack) {
                    element.show = false;
                }
            });
        }
    }
};
</script>
